"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var utilities_1 = require("@uifabric/utilities");
exports.Selection = utilities_1.Selection;
//# sourceMappingURL=Selection.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib-commonjs/utilities/selection/Selection.js
// module id = 868
// module chunks = 0